import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyAf1S2h6Un1PXX3ujTaQmaMgMTqbNjwSMo",
  authDomain: "be-positive-121e3.firebaseapp.com",
  projectId: "be-positive-121e3",
  storageBucket: "be-positive-121e3.firebasestorage.app",
  messagingSenderId: "432943240738",
  appId: "1:432943240738:web:9e7cf36cac03397a5a5c7b",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };
